// Common builder functions
import faker from "faker";

export const getPassword = (...args: any[]) =>
  `!0_Oo${faker.internet.password(...args)}`;
export const getUsername = faker.internet.userName;
export const genId = faker.random.uuid;
export const genNumericId = () => new Date().valueOf() + Math.random();
export const genWord = faker.lorem.word;
export const genToken = faker.random.alphaNumeric;
export const genName = faker.name.findName;
export const genFirstName = faker.name.firstName;
export const genLastName = faker.name.lastName;
export const genEmail = faker.internet.email;
export const genAvatar = faker.internet.avatar;
export const genCompanyName = faker.company.companyName;
export const genParagraph = faker.lorem.paragraph;
export const genTitle = () => faker.lorem.slug(3);
export const genWords = (words?: number) => faker.random.words(words);
export const genNumber = faker.random.number;
export const getBoolean = faker.random.boolean;
export const getRandomDate = faker.date.recent(200).toISOString();
export const genBiasBoolean = (bias: number) => {
  if (bias > 1 || bias < 0) {
    throw new Error(
      `Bias must be a number between 0 and 1. Value ${bias} is not valid`
    );
  }
  const random = Math.random();
  return random <= bias;
};
export const genDocument = (digits: number) => {
  let document = "";
  for (let i = 0; i < digits; i++) {
    document += genNumber(9);
  }
  return document;
};
export const genMobilPhone = (countryCode: string) => {
  return `+${countryCode} ${genDocument(3)} ${genDocument(3)} ${genDocument(
    4
  )}`;
};

export const fillNumber = (num: string, max?: number) => {
  const maxNumLength = max ? String(max).length : num.length;
  let newId = num;
  for (let i = 0; i < maxNumLength - num.length; i++) {
    newId = `0${newId}`;
  }
  return newId;
};

export const chooseRandom = <T>(arr: T[]): T => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const chooseRandomEnum = <T>(anEnum: T): T[keyof T] => {
  const enumValues = Object.keys(anEnum);
  const randomIndex = Math.floor(Math.random() * enumValues.length);
  const randomEnumKey = enumValues[randomIndex] as keyof T;
  const randomEnumValue = anEnum[randomEnumKey];
  return randomEnumValue;
};

export const genAddressNumber = () => {
  return faker.address.countryCode();
};

export const genStreetAddress = () => {
  return faker.address.streetAddress();
};

export const genPrices = () => {
  const discountTotal = genNumber({ min: 1, max: 3 });
  const subtotalBeforeTaxes = genNumber({ min: 1, max: 30 });
  const taxTotal = genNumber({ min: 0, max: subtotalBeforeTaxes / 5 });
  const total = subtotalBeforeTaxes + taxTotal;
  const subtotalZero = genNumber({ min: 1, max: 10 });
  const subtotalTaxedWithoutTaxes = genNumber({ min: 1, max: 15 });

  return {
    discountTotal,
    subtotalBeforeTaxes,
    taxTotal,
    total,
    subtotalTaxedWithoutTaxes,
    subtotalZero
  };
};
